import { useEffect, useState } from 'react'
import { Trans, useLingui } from '@lingui/react/macro'
import { Toast } from '@vgw/multibrand-fe-toast'
import { CircleLoadingAnimation } from '@vgw/multibrand-fe-circle-loading-animation'
import { usePurchaseLimitsQuery } from '@/features/purchase-limits/use-purchase-limits-query/use-purchase-limits-query'
import { PurchaseLimits } from 'apps/web/src/features/purchase-limits'
import { createFileRoute } from '@tanstack/react-router'
import { GameLimitsInfo } from '@/features/purchase-limits/game-limits-info'
import { TertiaryPageLayout } from '@/routes/-tertiary-page-layout'

export const Route = createFileRoute('/_app/your-play/gameplay-limits/all')({
  component: GameLimits,
})

function GameLimits() {
  const { limits, isPending, error } = usePurchaseLimitsQuery()
  const [showToast, setShowToast] = useState(false)
  const { t } = useLingui()

  useEffect(() => {
    setShowToast(Boolean(error))
  }, [error])

  return (
    <TertiaryPageLayout
      infoDrawerContent={<GameLimitsInfo />}
      headerText={t`Gameplay Limits`}
    >
      <Toast
        open={showToast}
        variant="warning"
        close={false}
        onOpenChange={setShowToast}
        className="mx-3 text-status-muted-surface-content data-[state=closed]:animate-fade-out"
        description={<Trans>Something went wrong. Please try again</Trans>}
      />

      {!!isPending && <CircleLoadingAnimation className="mx-auto mt-[60px]" />}

      {!isPending && !error && <PurchaseLimits limits={limits} />}
    </TertiaryPageLayout>
  )
}
